var map = {
	"./img_1.jpg": 37683,
	"./img_2.jpg": 89874,
	"./img_3.jpg": 51139,
	"./img_4.jpg": 46857,
	"./img_5.jpg": 57632,
	"./img_6.jpg": 80967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69412;